import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import 'Components/EmailCompetition/Countdown.scss';

const calculateTimeLeft = (targetDate) => {
  const difference = new Date(targetDate).getTime() - new Date().getTime();

  if (difference <= 0) {
    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    };
  }

  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)).toString().padStart(2, '0'),
    hours: Math.floor((difference / (1000 * 60 * 60)) % 24).toString().padStart(2, '0'),
    minutes: Math.floor((difference / 1000 / 60) % 60).toString().padStart(2, '0'),
    seconds: Math.floor((difference / 1000) % 60).toString().padStart(2, '0'),
  };
};

const Countdown = ({ targetDate, textColor }) => {
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(targetDate));

  useEffect(() => {
    if (new Date(targetDate).getTime() <= new Date().getTime()) {
      return null;
    }

    const timer = setInterval(() => {
      const updatedTimeLeft = calculateTimeLeft(targetDate);
      setTimeLeft(updatedTimeLeft);

      if (Object.values(updatedTimeLeft).every(value => value === '00')) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="show-counter">
      <a className="countdown-link" style={{ color: textColor }}>
        <div className="countdown">
          <p style={{ color: textColor }}>{timeLeft.days}</p>
          <span style={{ color: textColor }}>Days</span>
        </div>
        <p style={{ color: textColor }}>:</p>
        <div className="countdown">
          <p style={{ color: textColor }}>{timeLeft.hours}</p>
          <span style={{ color: textColor }}>Hours</span>
        </div>
        <p style={{ color: textColor }}>:</p>
        <div className="countdown">
          <p style={{ color: textColor }}>{timeLeft.minutes}</p>
          <span style={{ color: textColor }}>Minutes</span>
        </div>
        <p style={{ color: textColor }}>:</p>
        <div className="countdown">
          <p style={{ color: textColor }}>{timeLeft.seconds}</p>
          <span style={{ color: textColor }}>Seconds</span>
        </div>
      </a>
    </div>
  );
};

Countdown.propTypes = {
  targetDate: PropTypes.string.isRequired,
  textColor: PropTypes.string,
};

Countdown.defaultProps = {
  textColor: '#FFFFFF',
};

export default Countdown;
